import axios from 'axios';
import { getConfigProperty, getLocale } from '@/common/oldMobile';
import { paramsSerializer } from '@/_http/utils';
import fppBotDefence from '@/botdefence/fppBotDefence';
import createRetryRejector from '@/botdefence/createRetryRejector';
import { isNikeoneEnabled } from 'nike-ui/src/components/nikeone';

if (!axios.__nike_setup) {
    throw Error('axios wrong create order');
}
const n1Client = axios.create({
    headers: { 'Content-Language': getLocale() },
    baseURL: getConfigProperty('nikeone.service_endpoint'),
    paramsSerializer: paramsSerializer.traditional
});

if (!isNikeoneEnabled) {
    n1Client.interceptors.request.use(config => {
        const msg = `Nikeone service endpoint is not configured, aborting request to ${config.url}`;
        console.warn(msg);
        return Promise.reject(msg);
    });
} else {
    n1Client.interceptors.response.use(response => response.data, createRetryRejector(n1Client, fppBotDefence));
    n1Client.interceptors.request.use(config => {
        if (config.method.toLowerCase() === 'get') {
            config.params = config.params || {};
            config.params.channel = 'Mobile';
        }
        return config;
    });
}

export default n1Client;
